import React from "react";
import { useState, useEffect } from "react";
import "./Navbar.css";
import { navItems } from "./NavbarItems.js";
import { Contacto } from "../Contacto/Contacto";
import { FiMenu } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";

export const Navbar = () => {
  const [progress, setProgress] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onScroll = () => {
    setProgress(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const scrollToSection = (e, id) => {
    e.preventDefault();
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    toggleMenu();
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const screenHeight = window.innerHeight;

  // Add and remove 'disable-scroll' class to body element to disable scrolling
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("disable-scroll");
    } else {
      document.body.classList.remove("disable-scroll");
    }

    // Cleaning effect when disassembling the component
    return () => {
      document.body.classList.remove("disable-scroll");
    };
  }, [isMenuOpen]);

  return (
    <nav className="nav-container">
      {progress > screenHeight - 96 ? (
        <p className="logo logo-verdivia" onClick={scrollToTop}>
          Verdivia
        </p>
      ) : (
        <p className="logo logo-identidad" onClick={scrollToTop}>
          Identidad Mendocina
        </p>
      )}

      <div className="menu-icon">
        {isMenuOpen ? (
          <picture onClick={toggleMenu}>
            <RxCross2 />
          </picture>
        ) : (
          <picture onClick={toggleMenu}>
            <FiMenu />
          </picture>
        )}

        <ul className={isMenuOpen ? "active" : ""}>
          {navItems.map((item) => (
            <li key={item.id}>
              <a
                href={item.href}
                onClick={(e) => scrollToSection(e, item.section)}
              >
                {item.name}
              </a>
            </li>
          ))}
          <Contacto text="Contactanos" className="btn-contactanos" />
        </ul>
      </div>
    </nav>
  );
};
